import React, { useState, useEffect } from "react";
import "../master.scss"
import { _Api } from "../../api/_call";
import { error, loading, Updateloading } from "../../common/helpers/toastify";
import { useTranslation } from 'react-i18next';

const Editscrvicelaboure = (props) => {
    const { setEditItem, dataid, setShowedit, create, setDataid, setCreate } = props
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
    const [name, setName] = useState()
    const [code, setCode] = useState()
    const { t } = useTranslation();
    const [active, setActive] = useState(true)
    const [priceedit, SetPriceedit] = useState()
    const setscrvicelabourcreate = async () => {
        if (!name) {
            error(t("Name is required."))
            return
        }
        if (!code) {
            error(t("Code is required."))
            return
        } 
        // else {
        //     if (typeof code === 'string') {
        //         let checkspace = code.includes(' ');
        //         if (checkspace) {
        //             error(t('Please remove space in code'));
        //             return;
        //         }
        //     }
        // }
        if (!priceedit) {
            error(t("Price is required."))
            return
        }
        let GetloadingID = loading();
        try {
            let postdata = {
                "name": name ? name : "",
                "code": code ? code : "",
                "Status": active ? "1" : "0",
                "price": priceedit
            }
            let res = await _Api(postdata, `api/v1/App/master/serviceLabourMasterCreate`)
            if (res?.code === 200) {
                Updateloading(t, GetloadingID, (res?.message));
                setEditItem(false)
                setShowedit(true)
                setCreate(false)
                setDataid("")
            } else {
                Updateloading(t, GetloadingID, (res.errors), 'error');
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    const setscrvicelabouredit = async () => {
        if (!name) {
            error(t("Name is required."))
            return
        }
        if (!code) {
            error(t("Code is required."))
            return
        } 
        // else {
        //     if (typeof code === 'string') {
        //         let checkspace = code.includes(' ');
        //         if (checkspace) {
        //             error(t('Please remove space in code'));
        //             return;
        //         }
        //     }
        // }
        let GetloadingID = loading();
        try {
            let postdata = {
                "id": dataid,
                "name": name ? name : "",
                "code": code ? code : "",
                "Status": active ? "1" : "0",
                "price": parseFloat(priceedit)
            }
            let res = await _Api(postdata, `api/v1/App/master/serviceLabourMasterEdit`)
            if (res?.code === 200) {
                Updateloading(t, GetloadingID, (res?.message));
                setEditItem(false)
                setShowedit(true)
                setCreate(false)
                setDataid("")
            } else {
                Updateloading(t, GetloadingID, (res?.message), 'error');
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    const viewscrvice = async () => {
        if (create) {
            setName("")
            setCode("")
            setActive(true)
            SetPriceedit("")
        } else {
            try {
                const postdata = {
                    id: dataid
                }
                const res = await _Api(postdata, `api/v1/App/master/serviceLabourMasterView`)
                if (res?.code === 200) {
                    setName(res?.data?.name)
                    setCode(res?.data?.code)
                    if (res?.data?.Status === "1") {
                        setActive(true)
                    } else {
                        setActive(false)
                    }
                    SetPriceedit(res?.data?.price)
                }
            }
            catch (err) {
                console.log(err, "err")
            }
        }

    }
    useEffect(() => {
        if (dataid || create) {
            viewscrvice();
        }
        // eslint-disable-next-line
    }, [dataid, create]);
    return (
        <>
            <div className="edit-item-area bg-white">
                <div className="edit-item-area-header d-flex align-items-center justify-space-between mb-4">
                    <div className="me-auto">
                        <label className="d-block">{t("Name")}: {name ? name : ""}</label>
                        <label className="d-block">{t("Code")}: {code ? code : ""}</label>
                    </div>
                    <button className="square-btn square-btn-white btn-close focus-none" onClick={() => {
                        setEditItem(false); setCreate(false)
                        setDataid("")
                    }}></button>
                    <button className="square-btn " onClick={() => {
                        dataid ? setscrvicelabouredit() : setscrvicelabourcreate()
                        setEditItem(false); setCreate(false)
                        setDataid("")
                    }}><img src={base_assets + 'images/icons/white-save.png'} alt="" /></button>
                </div>
                <div className="edit-item-area-body">
                    <div className="row mx-0">
                        <div className="col-md-8 ps-0">
                            <div className="v3-input-group">
                                <label className="v3-input-group-label">{t("Name")} <sup>*</sup></label>
                                <input className="v3-input-group-input w-100"
                                    value={name || ''}
                                    onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="v3-input-group">
                                <label className="v3-input-group-label">{t("Code")} <sup>*</sup></label>
                                <input className="v3-input-group-input w-100"
                                    value={code || ''}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                            </div>

                            <div className="v3-input-group">
                                <label className="v3-input-group-label">{t("Price")}<sup>*</sup></label>
                                <input className="v3-input-group-input w-100"
                                    value={priceedit || ''}
                                    onChange={(e) => SetPriceedit(e.target.value)} />
                            </div>

                        </div>
                        <div className="col-md-3 offset-md-1 pe-0 text-end">
                            <div className="form-check form-switch ps-0">
                                <label className="form-check-label" htmlFor="active">{t("Active")}</label>
                                <input className="form-check-input float-none ms-2" type="checkbox" id="active"
                                    checked={active ? true : false}
                                    onChange={(e) => setActive(e.target.checked)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Editscrvicelaboure;